var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M7 0h3M3 1h4m3 0h1M1 2h2m6 0h2M1 3h1m1 0h2m5 0h1M1 4h1m1 0h1m3 0h2m1 0h1M1 5h1m3 0h1m2 0h1m1 0h1M1 6h1m3 0h2m3 0h1M1 7h1m8 0h1M1 8h1m8 0h1M1 9h1m8 0h1M1 10h1m1 0h1m3 0h4m-9 1h5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "gray",
    d: "M7 1h3M3 2h4M2 3h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#16060c",
    d: "M7 2h2M5 3h2M3 5h1M3 6h1M3 7h1M3 8h1M3 9h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cc5a18",
    d: "M7 3h2M4 4h2M4 5h1M4 6h1M4 7h1M4 8h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a02500",
    d: "M9 3h1M6 4h1M6 5h2M5 7h2M5 8h2m-3 2h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M2 4h1M2 5h1M2 6h1M2 7h1M2 8h1M2 9h1m-1 1h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#871b26",
    d: "M9 4h1M9 5h1M7 6h2M7 7h2M7 9h1m-2 1h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6d1d30",
    d: "M9 6h1M9 7h1M8 9h2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ccc100",
    d: "M7 8h3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff200",
    d: "M4 9h3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/xp.02f0600e8d4bbe782575fe5b9f570e98.svg";
export { ForwardRef as ReactComponent };